export default __webpack_public_path__ + "static/media/gel-buffer-empty.86cb4592.svg";